import { v4 as uuidv4 } from 'uuid';
import { getCookieByName } from '../../../../utils';

const DATALAYER_COOKIE_NAME = 'JuntoSessionID';
const initialState = {
  Modalidade: null,
  IS: null,
  Vigencia: null,
  CNPJ: null,
  ValorDoContrato: null,
  Premio: null,
};

const createDataLayerObject = () => {
  let SessionID = getCookieByName(DATALAYER_COOKIE_NAME);

  if (!SessionID) {
    SessionID = uuidv4();
  } else {
    SessionID = JSON.parse(SessionID);
  }

  window.JuntoDataLayer = { SessionID, ...initialState };
};

export const createGlobalDataLayer = () => {
  if (window.sessionStorage) {
    const storedDataLayer = sessionStorage.getItem('JuntoDataLayer');

    if (!storedDataLayer) {
      createDataLayerObject();
      sessionStorage.setItem('JuntoDataLayer', JSON.stringify(window.JuntoDataLayer));
    } else {
      window.JuntoDataLayer = JSON.parse(storedDataLayer);
    }
  } else {
    createDataLayerObject();
  }
};

export const addToGlobalDataLayer = (field, value) => {
  if (window.JuntoDataLayer) {
    window.JuntoDataLayer[field] = value;

    if (window.sessionStorage) {
      sessionStorage.setItem('JuntoDataLayer', JSON.stringify(window.JuntoDataLayer));
    }
  }
};

export const resetGlobalDataLayer = () => {
  if (window.sessionStorage) {
    const storedDataLayer = sessionStorage.getItem('JuntoDataLayer');

    if (storedDataLayer) {
      const { SessionID, CNPJ } = JSON.parse(sessionStorage.getItem('JuntoDataLayer'));

      window.JuntoDataLayer = { ...initialState, SessionID, CNPJ };
      sessionStorage.setItem('JuntoDataLayer', JSON.stringify(window.JuntoDataLayer));
    }
  }
};

export const getSessionID = () => {
  const StorageDataLayer = JSON.parse(sessionStorage.getItem('JuntoDataLayer'));

  if (StorageDataLayer) {
    return StorageDataLayer.SessionID;
  }
  return '';
};
